import * as React from 'react';
import {
  ActionChannel,
  FramelyAction,
  ActionType,
  ParameterType,
  MessageTemplate,
  ParameterConfig,
  Attribute,
  DataQuery,
  ClearSlotAction,
  FillSlotAction,
  RecheckAction,
  ItemActionChannelData,
  ItemAction,
  IntentStartAction,
  IntentEndAction,
  IntentAbortAction,
  ListAction,
  ListActionChannelData,
  CloseSessionAction,
  HandOffAction,
  IntentAssignment,
  IntentInfo,
  Reference,
  AugmentMeta
} from '@interface/index';

import {
  SourceType,
  INTEGRATION_TYPE,
  RESPONSE_CHANNEL_TYPE,
  USER_CHANNEL_NAME_MAP,
  API,
  NiCommonCascader,
  SELECTION_KEY,
  SelectionOption,
  COPILOT_ACTION_KEYS,
  PAGE_TYPE,
  defaultBorder,
  defaultBorderRadius
} from '@config/index';

import {
  NiSelect,
  BodyGroup,
  NiCard,
  niConfirm,
  ReferenceTextArea,
  NiButton,
  TextResponse,
  NiInput,
  NiForm,
  NiTable,
  NiTabs,
  NiMenu,
  NiBooleanRadio,
  ExprMode,
  AddButton
} from '@component/index';

import { cloneDeep, isEqual } from 'lodash';

import { localizedString } from '@locale/index';

import {
  isLanguageAgent,
  isStructAgent,
  getMessageTemplates,
  dataQueryToParameter,
  ParameterMapStore,
  getFullName,
  instance,
  getFormattedName
} from '@lib/index';

import {
  Space,
  InputNumber,
  message,
  Switch,
  Dropdown,
  Menu
} from 'antd';

import {
  CaretDownOutlined,
  DeleteOutlined,
  PlusOutlined,
  DownOutlined,
  CloseOutlined
} from '@ant-design/icons';

import { FormattedMessage } from 'react-intl';

import './action-list.less';
import CodeTextArea from '@component/code-textarea/code-textarea';
import { PromptListHandle } from '@component/prompt/new-prompt-list';
import { PromptStringList } from '@component/prompt/prompt-string-list';
import EmptyLine from '@component/business-component/empty-line/empty-line';
import { AugmentMetaComp } from '@page/agent/component/augment-meta';

type ActionListProps = {
  title: string | React.ReactNode;
  frame: any;
  data: FramelyAction[];
  disabled?: boolean;
  actionsTypes: string[];
  selectedParameters: Attribute[];
  globalSelectedParameters: Attribute[];
  availableIntents: IntentInfo[];
  dataQueries: DataQuery[];
  onChange: (actions: FramelyAction[]) => void;
  showTitleLine?: boolean;
  singleAction?: boolean;
  singleChannel?: boolean;
  hideNumberOfEntries?: boolean;
  hideSource?: boolean;
  inModal?: boolean;
};

type ActionListState = {
  data: FramelyAction[];
  // msgTemps: { [key: string]: MessageTemplate[] };
  itemActiveTabs: { [index: number]: string };
  listActiveTabs: { [index: number]: string };
};

export class ActionList extends React.Component<ActionListProps, ActionListState> {
  constructor(props: ActionListProps) {
    super(props);

    this.state = {
      data: cloneDeep(props.data) || [],
      itemActiveTabs: {},
      listActiveTabs: {}
    };
  }
  actionListener: any;
  componentDidMount() {
    this.actionListener = instance.on(COPILOT_ACTION_KEYS.ADD_RESPONSE_ACTION, (args: any) => {

      if (!args || !args.responseActionType) {
        message.warning('Response action type should be specified!');
        return;
      }

      let actionType = '';

      // singleValueMessage, multipleValueMessage, skillStart, skillAbort, handOff, closeSession
      switch (args.responseActionType) {
        case 'singleValueMessage':
          actionType = ActionType.ITEM;
          break;
        case 'multipleValueMessage':
          actionType = ActionType.LIST;
          break;
        case 'skillStart':
          actionType = ActionType.INTENT_START;
          break;
        case 'skillAbort':
          actionType = ActionType.INTENT_ABORT;
          break;
        case 'handOff':
          actionType = ActionType.HAND_OFF;
          break;
        case 'closeSession':
          actionType = ActionType.CLOSE_SESSION;
          break;
        default:
          break;
      }

      const { actionsTypes } = this.props;
      const { data } = this.state;

      if (actionsTypes.indexOf(actionType) === -1 || this.disableActionTypeWithActions(actionType, data)) {
        message.warning('the action type is not supported!');
        return;
      }

      this.handleAddAction(actionType);
    });
    this.onInit();
  }

  componentWillUnmount() {
    this.actionListener();
  }

  componentDidUpdate(prevProps: ActionListProps) {
    if (!isEqual(prevProps.data, this.props.data)) {
      this.onInit();
    }
  }

  onInit = async () => {
    this.setState({
      data: cloneDeep(this.props.data) || []
      // msgTemps: await getMessageTemplates()
    });
  }

  disableActionTypeWithActions = (actionType: string, actions: FramelyAction[]): boolean => {

    for (const a of actions) {
      switch (actionType) {
        case ActionType.INTENT_END:
          switch (a.type) {
            case ActionType.FILL_SLOT:
            case ActionType.CLEAR_SLOT:
            case ActionType.RECHECK:
            case ActionType.INTENT_ABORT:
              return true;
            default:
              break;
          }
          break;
        case ActionType.FILL_SLOT:
        case ActionType.CLEAR_SLOT:
        case ActionType.RECHECK:
        case ActionType.INTENT_ABORT:
          if (a.type === ActionType.INTENT_END) {
            return true;
          }
          break;
        case ActionType.INTENT_START:
          if (a.type === ActionType.INTENT_START) {
            return true;
          }
          break;
        default:
          break;
      }
    }
    return false;
  }

  render() {

    const { disabled, title, actionsTypes, showTitleLine, singleAction } = this.props;
    const { data } = this.state;

    return (singleAction
      ? this.getActionsDom()
      : <BodyGroup
        noPadding
        noTitleLine={!showTitleLine}
        key="action-list"
        className="action-list"
        title={title}
        extra={<NiSelect
          key="repsonse-select"
          style={{
            alignSelf: 'flex-end'
          }}
          className="add-require__Select"
          disabled={disabled}
          placeholder={localizedString('response_add_placeholder')}
          suffixIcon={<CaretDownOutlined />}
          value={undefined}
          onChange={this.handleAddAction}
        >
          {actionsTypes.indexOf(ActionType.CLEAR_SLOT) !== -1 &&
            <NiSelect.Option
              disabled={this.disableActionTypeWithActions(ActionType.CLEAR_SLOT, data)}
              key="select-option-clear-slot"
              value={ActionType.CLEAR_SLOT}
            >
              {localizedString('response_type_clear_slot_action')}
            </NiSelect.Option>
          }
          {actionsTypes.indexOf(ActionType.FILL_SLOT) !== -1 &&
            <NiSelect.Option
              disabled={this.disableActionTypeWithActions(ActionType.FILL_SLOT, data)}
              key="select-option-fill-slot"
              value={ActionType.FILL_SLOT}
            >
              {localizedString('response_type_fill_slot_action')}
            </NiSelect.Option>
          }
          {actionsTypes.indexOf(ActionType.RECHECK) !== -1 &&
            <NiSelect.Option
              disabled={this.disableActionTypeWithActions(ActionType.RECHECK, data)}
              key="select-option-recheck"
              value={ActionType.RECHECK}
            >
              {localizedString('response_type_recheck_action')}
            </NiSelect.Option>
          }
          {actionsTypes.indexOf(ActionType.INTENT_END) !== -1 &&
            <NiSelect.Option
              disabled={this.disableActionTypeWithActions(ActionType.INTENT_END, data)}
              key="select-option-intent-end"
              value={ActionType.INTENT_END}
            >
              {localizedString('response_type_intent_end_action')}
            </NiSelect.Option>
          }
          {actionsTypes.indexOf(ActionType.ITEM) !== -1 &&
            <NiSelect.Option
              key="select-option-text-response"
              value={ActionType.ITEM}
            >
              {localizedString('response_type_item_action')}
            </NiSelect.Option>
          }
          {actionsTypes.indexOf(ActionType.LIST) !== -1 &&
            <NiSelect.Option
              key="select-option-textlist-response"
              value={ActionType.LIST}
            >
              {localizedString('response_type_list_action')}
            </NiSelect.Option>
          }
          {actionsTypes.indexOf(ActionType.INTENT_START) !== -1 &&
            <NiSelect.Option
              disabled={!!(data.find((response: FramelyAction) =>
                response.type === ActionType.INTENT_START))}
              key="select-option-intent-response"
              value={ActionType.INTENT_START}
            >
              {localizedString('response_type_intent_start_action')}
            </NiSelect.Option>
          }
          {actionsTypes.indexOf(ActionType.INTENT_ABORT) !== -1 &&
            <NiSelect.Option
              key="select-option-intent-abort-response"
              value={ActionType.INTENT_ABORT}
            >
              {localizedString('response_type_intent_abort_action')}
            </NiSelect.Option>
          }
          {actionsTypes.indexOf(ActionType.HAND_OFF) !== -1 &&
            <NiSelect.Option
              key="select-option-hand-off-response"
              value={ActionType.HAND_OFF}
            >
              {localizedString('response_type_hand_off_action')}
            </NiSelect.Option>
          }
          {actionsTypes.indexOf(ActionType.CLOSE_SESSION) !== -1 &&
            <NiSelect.Option
              key="select-option-close-session-response"
              value={ActionType.CLOSE_SESSION}
            >
              {localizedString('response_type_close_session_action')}
            </NiSelect.Option>
          }
          {
            actionsTypes.indexOf(ActionType.AUGMENT_META) !== -1 &&
            <NiSelect.Option
              key="select-option-augment-meta-response"
              value={ActionType.AUGMENT_META}
            >
              {localizedString('response_type_augment_meta_action')}
            </NiSelect.Option>
          }
        </NiSelect>
        }
      >
        {data.length
          ? this.getActionsDom()
          : <EmptyLine text={localizedString('action_list_empty')} />
        }
      </BodyGroup>
    );
  }

  getSuggestionData = (): ParameterConfig[] => {
    const props = this.props;

    return [
      ...(props.globalSelectedParameters || []),
      ...(props.selectedParameters || []),
      ...(props.dataQueries || []).map(dataQueryToParameter)
    ] as ParameterConfig[];
  };

  getActionsDom() {
    const { data } = this.state;

    const responseSequenceDom = [];
    for (const [i, response] of (data || []).entries()) {
      switch (response.type) {
        case 'clear_slot_action':
          responseSequenceDom.push(
            this.getClearSlotActionDiv(i, response)
          );
          break;
        case 'fill_slot_action':
          responseSequenceDom.push(
            this.getFillSlotActionDiv(i, response)
          );
          break;
        case 'recheck_action':
          responseSequenceDom.push(
            this.getRecheckActionDiv(i, response)
          );
          break;
        case 'intent_end_action':
          responseSequenceDom.push(
            this.getIntentEndActionDiv(i, response)
          );
          break;
        case 'item_action':
          responseSequenceDom.push(
            this.getItemResponseDiv(i, response, 'restful')
          );
          break;
        case 'list_action':
          responseSequenceDom.push(
            this.getListResponseDiv(i, response, 'restful')
          );
          break;
        case 'intent_start_action':
          responseSequenceDom.push(
            this.getIntentStartActionDiv(i, response)
          );
          break;
        case 'intent_abort_action':
          responseSequenceDom.push(
            this.getIntentAbortActionDiv(i, response)
          );
          break;
        case 'hand_off_action':
          responseSequenceDom.push(
            this.getHandOffActionDiv(i, response)
          );
          break;
        case 'close_session_action':
          responseSequenceDom.push(
            this.getCloseSessionActionDiv(i, response)
          );
          break;
        case 'augment_meta':
          responseSequenceDom.push(
            this.getAugmentMetaActionDiv(i, response)
          );
          break;
        default:
          break;
      }
    }

    return responseSequenceDom;
  }

  getClearSlotActionDiv = (idx: number, action: ClearSlotAction) => {
    const { disabled, frame } = this.props;
    const { data } = this.state;

    if (!data) {
      return '';
    }

    return (
      <NiCard
        title={localizedString('response_type_clear_slot_action')}
        className="response-card"
        key={`response-block-${ActionType.CLEAR_SLOT}-${idx}`}
        extra={disabled || !!frame.originKey ? [] : <NiButton
          style={{
            border: 0
          }}
          onClick={this.handleDeleteResponse.bind(this, idx)}
        >
          <DeleteOutlined />
        </NiButton>}
        hoverExtra={true}
      >
        <NiForm
          direction="vertical"
          items={[{
            key: 'intent',
            label: localizedString('target_slot'),
            content: <NiCommonCascader
              disabled={disabled || !!frame.originKey}
              selectionkey={SELECTION_KEY.AVAILABLE_SLOT}
              style={{ width: '100%' }}
              rootpath={[{
                value: frame.id as string,
                value_type: frame.type
              }]}
              value={action.slot}
              onChange={(value: string[], selectedOptions?: SelectionOption[]) => {

                if (!selectedOptions) {
                  return;
                }

                const ref: Reference = selectedOptions.map((opt: SelectionOption) => ({
                  id: opt.value,
                  name: opt.label,
                  type: opt.valueType
                })) as Reference;

                this.handleUpdateResponseByField(idx, action, 'slot', ref);
              }}
            />
          }]}
        />
      </NiCard>
    );
  };

  getFillSlotActionDiv = (idx: number, action: FillSlotAction) => {
    const { disabled, frame } = this.props;
    const { data } = this.state;

    if (!data) {
      return '';
    }

    return (
      <NiCard
        title={localizedString('response_type_fill_slot_action')}
        className="response-card"
        key={`response-block-${ActionType.FILL_SLOT}-${idx}`}
        extra={disabled || !!frame.originKey ? [] : <NiButton
          style={{
            border: 0
          }}
          onClick={this.handleDeleteResponse.bind(this, idx)}
        >
          <DeleteOutlined />
        </NiButton>}
        hoverExtra={true}
      >
        <NiForm
          direction="vertical"
          items={[{
            key: 'intent',
            label: localizedString('target_slot'),
            content: <NiCommonCascader
              disabled={disabled || !!frame.originKey}
              selectionkey={SELECTION_KEY.AVAILABLE_SLOT}
              style={{ width: '100%' }}
              rootpath={[{
                value: frame.id,
                value_type: frame.type
              }]}
              value={action.slot}
              onChange={(value: string[], selectedOptions?: SelectionOption[]) => {

                if (!selectedOptions) {
                  return;
                }

                const ref: Reference = selectedOptions.map((opt: SelectionOption) => ({
                  id: opt.value,
                  name: opt.label,
                  type: opt.valueType
                })) as Reference;

                this.handleUpdateResponseByField(idx, action, 'slot', ref);
              }}
            />
          },
          {
            key: 'code-expression',
            label: localizedString('code_expression'),
            content: <ReferenceTextArea
              rawCodeMode
              rawCodeType={frame}
              disabled={disabled || !!frame.originKey}
              data={action.codeExpression}
              initParameters={[]}
              parameterMap={{}}
              update={(next: string) => {
                this.handleUpdateResponseByField(idx, action, 'codeExpression', next);
              }}
              comment={action.codeComment}
              onCommentChange={(value: string) => {
                this.handleUpdateResponseByField(idx, action, 'codeComment', value);
              }}
            />
          }]}
        />
      </NiCard>
    );
  };

  getRecheckActionDiv = (idx: number, action: RecheckAction) => {
    const { disabled, frame } = this.props;
    const { data } = this.state;

    if (!data) {
      return '';
    }

    return (
      <NiCard
        title={localizedString('response_type_recheck_action')}
        className="response-card"
        key={`response-block-${ActionType.RECHECK}-${idx}`}
        extra={disabled || !!frame.originKey ? [] : <NiButton
          style={{
            border: 0
          }}
          onClick={this.handleDeleteResponse.bind(this, idx)}
        >
          <DeleteOutlined />
        </NiButton>}
        hoverExtra={true}
      >
        <NiForm
          direction="vertical"
          items={[{
            key: 'slot',
            label: localizedString('target_slot'),
            content: <NiCommonCascader
              disabled={disabled || !!frame.originKey}
              selectionkey={SELECTION_KEY.AVAILABLE_SLOT}
              style={{ width: '100%' }}
              rootpath={[{
                value: frame.id as string,
                value_type: frame.type
              }]}
              value={action.slot}
              onChange={(value: string[], selectedOptions?: SelectionOption[]) => {

                if (!selectedOptions) {
                  return;
                }

                const ref: Reference = selectedOptions.map((opt: SelectionOption) => ({
                  id: opt.value,
                  name: opt.label,
                  type: opt.valueType
                })) as Reference;

                this.handleUpdateResponseByField(idx, action, 'slot', ref);
              }}
            />
          }]}
        />
      </NiCard>
    );
  };

  getIntentEndActionDiv = (idx: number, action: IntentEndAction) => {
    const { disabled, frame } = this.props;
    const { data } = this.state;

    if (!data) {
      return '';
    }

    return (
      <NiCard
        title={localizedString('response_type_intent_end_action')}
        titleExtra={<NiBooleanRadio
          disabled={disabled || !!frame.originKey}
          value={action && action.soft || false}
          onChange={(value: boolean) => {
            this.handleUpdateResponseByField(idx, action, 'soft', value);
          }}
          falseWord={localizedString('intent_end_action_hard')}
          trueWord={localizedString('intent_end_action_soft')}
          style={{ marginLeft: 48 }}
        />}
        className="response-card no-content"
        key={`response-block-${ActionType.INTENT_END}-${idx}`}
        extra={disabled || !!frame.originKey ? [] : <NiButton
          style={{
            border: 0
          }}
          onClick={this.handleDeleteResponse.bind(this, idx)}
        >
          <DeleteOutlined />
        </NiButton>}
        hoverExtra={true}
      >
      </NiCard>
    );
  };

  getAugmentMetaActionDiv = (idx: number, action: AugmentMeta) => {
    const { disabled, frame, selectedParameters } = this.props;
    const { data } = this.state;

    if (!data) {
      return '';
    }

    return (
      <NiCard
        title={localizedString('response_type_augment_meta_action')}
        className="response-card"
        key={`response-block-${ActionType.AUGMENT_META}-${idx}`}
        extra={disabled || (frame && !!frame.originKey) ? [] : <NiButton
          style={{
            border: 0
          }}
          onClick={this.handleDeleteResponse.bind(this, idx)}
        >
          <DeleteOutlined />
        </NiButton>}
        hoverExtra={true}
      >
        <AugmentMetaComp
          frame={frame}
          selectedParameters={this.props.selectedParameters}
          data={action}
          disabled={disabled || (frame && !!frame.originKey)}
          onChange={(next: AugmentMeta) => {
            this.handleUpdateResponse(idx, next);
          }}
        />
      </NiCard>
    );
  };

  handleResponseDeletion = (deletedIndex: number) => {
    this.setState(prevState => {
      const newItemActiveTabs: { [index: number]: string } = {};
      const newListActiveTabs: { [index: number]: string } = {};

      // 更新 itemActiveTabs：保留 deletedIndex 之前的；大于 deletedIndex 的键 - 1
      Object.keys(prevState.itemActiveTabs).forEach(key => {
        const idx = Number(key);
        if (idx < deletedIndex) {
          newItemActiveTabs[idx] = prevState.itemActiveTabs[idx];
        } else if (idx > deletedIndex) {
          newItemActiveTabs[idx - 1] = prevState.itemActiveTabs[idx];
        }
        // 如果 idx === deletedIndex，则直接跳过（即删除该项）
      });

      // 同理更新 listActiveTabs
      Object.keys(prevState.listActiveTabs).forEach(key => {
        const idx = Number(key);
        if (idx < deletedIndex) {
          newListActiveTabs[idx] = prevState.listActiveTabs[idx];
        } else if (idx > deletedIndex) {
          newListActiveTabs[idx - 1] = prevState.listActiveTabs[idx];
        }
      });

      return {
        itemActiveTabs: newItemActiveTabs,
        listActiveTabs: newListActiveTabs
      };
    });
  };

  getItemResponseDiv = (idx: number, response: ItemAction, channel: string) => {
    const { data } = this.state;
    const { disabled = false, frame } = this.props;

    if (!data) {
      return '';
    }

    // RESTFUL 为默认渠道，其余渠道取自 otherChannelData
    const restful = INTEGRATION_TYPE.RESTFUL;
    const otherChannels = response.otherChannelData || [];
    const channels = [restful, ...otherChannels.map(item => item.channel)];
    const activeTabKey =
      (this.state.itemActiveTabs && this.state.itemActiveTabs[idx]) || channels[0];

    // 根据激活的 tab 渲染对应的内容
    let tabContent;
    if (activeTabKey === restful) {
      tabContent = (
        <CodeTextArea
          key={activeTabKey}
          inModal={this.props.inModal}
          data={response.content[0]}
          disabled={disabled || isStructAgent()}
          update={(next) => {
            const nextResponse = cloneDeep(response);
            nextResponse.content = [next];
            this.handleUpdateResponse(idx, nextResponse);
          }}
        />
      );
    } else {

      const tabIndex = channels.indexOf(activeTabKey) - 1;
      tabContent = (
        <CodeTextArea
          key={activeTabKey}
          inModal={this.props.inModal}
          data={
            (response.otherChannelData &&
              response.otherChannelData[tabIndex].content[0]) ||
            ''
          }
          disabled={disabled || isStructAgent()}
          update={(next) => {
            const nextResponse = cloneDeep(response);
            if (!nextResponse.otherChannelData) {
              nextResponse.otherChannelData = [];
            }
            nextResponse.otherChannelData[tabIndex].content = [next];
            this.handleUpdateResponse(idx, nextResponse);
          }}
        />
      );
    }

    return (
      <NiCard
        title={
          <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <span className="response__title_text" style={{ marginRight: 16 }}>
              {localizedString('response_type_item_action')}
            </span>
            <Menu
              mode="horizontal"
              selectedKeys={[activeTabKey]}
              style={{
                border: 'none',
                background: 'transparent',
                lineHeight: '30px', // 保持与标题对齐
                width: '100%'
              }}
              onClick={(e) => {
                this.setState((prevState: any) => ({
                  itemActiveTabs: { ...prevState.itemActiveTabs, [idx]: e.key },
                }));
              }}
            >
              {channels.map((ch, index) => {
                const isClosable = index !== 0 && !disabled && !frame.originKey;
                return (
                  <Menu.Item
                    key={ch}
                    style={{
                      padding: '0 8px',
                      borderBottom: activeTabKey === ch ? '2px solid #1890ff' : 'none'
                    }}
                  >
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                      {USER_CHANNEL_NAME_MAP[ch]}
                      {isClosable && (
                        <CloseOutlined
                          onClick={(e) => {
                            e.stopPropagation();
                            // 保持原有的删除逻辑
                            const nextResponse = cloneDeep(response);
                            if (nextResponse.otherChannelData) {
                              nextResponse.otherChannelData = nextResponse.otherChannelData.filter(
                                (item: any) => item.channel !== ch
                              );
                            }
                            this.handleUpdateResponse(idx, nextResponse);
                            if (activeTabKey === ch) {
                              this.setState((prevState: any) => ({
                                itemActiveTabs: {
                                  ...prevState.itemActiveTabs,
                                  [idx]: channels[0],
                                },
                              }));
                            }
                          }}
                          style={{
                            marginLeft: 8,
                            fontSize: 12 // 调整图标大小
                          }}
                        />
                      )}
                    </span>
                  </Menu.Item>
                );
              })}

            </Menu>
          </div>
        }
        className={`response-card simple-reply-card ${disabled || isStructAgent() ? 'disabled' : ''
          }`}
        key={`response-block-${ActionType.ITEM}-${idx}`}
        extra={
          disabled ? (
            []
          ) : (
            <Space>
              {frame && !frame.originKey && !disabled &&
                <Dropdown
                  key="dropdown"
                  placement="bottomRight"
                  overlay={
                    <Menu
                      key="add-annotation"
                      className="add-annotation"
                    >
                      {Object.entries(INTEGRATION_TYPE)
                        .filter(([label, value]: [string, string]) => value !== INTEGRATION_TYPE.RESTFUL)
                        .map(([label, value]: [string, string]) =>
                          <Menu.Item
                            style={{ height: 40 }}
                            key={`attr-module-option-${label}`}
                            disabled={value === INTEGRATION_TYPE.RESTFUL ||
                              (response.otherChannelData &&
                                response.otherChannelData.findIndex((item: ItemActionChannelData) => item.channel === value) > -1)}
                            title={USER_CHANNEL_NAME_MAP[value]}
                            onClick={(e: any) => {

                              const nextResponse = cloneDeep(response);

                              if (!nextResponse.otherChannelData) {
                                nextResponse.otherChannelData = [];
                              }

                              nextResponse.otherChannelData.push({
                                channel: value,
                                content: ['']
                              });

                              this.handleUpdateResponse(idx, nextResponse);
                            }}
                          >
                            {USER_CHANNEL_NAME_MAP[value]}
                          </Menu.Item>)
                      }
                    </Menu>
                  }>
                  <div>
                    {/* {localizedString('add_channels')} */}
                    <PlusOutlined key="icon" />
                  </div>
                </Dropdown >
              }
              <NiButton
                style={{ border: 0 }}
                onClick={this.handleDeleteResponse.bind(this, idx)}
              >
                <DeleteOutlined />
              </NiButton>
            </Space>
          )
        }
        hoverExtra={true}
      >
        {tabContent}
      </NiCard>
    );
  };

  getListResponseDiv = (idx: number, response: ListAction, channel: string) => {
    const { data } = this.state;
    const {
      disabled = false,
      frame,
      singleAction,
      singleChannel,
      hideNumberOfEntries,
      hideSource,
    } = this.props;

    if (!data) {
      return '';
    }

    const singleRef = React.createRef<PromptListHandle>();
    const zeroRef = React.createRef<PromptListHandle>();

    // const suggestionData = this.getSuggestionData();
    const promptItems = [{
      key: 'single-prompts',
      label: localizedString('value_suggestion_single_prompts'),
      extra: response.singlePrompts && response.singlePrompts.length && <AddButton
        disabled={disabled || isStructAgent()}
        onClick={(e: any) => {
          singleRef.current?.add(e);
        }} /> || '',
      content: <PromptStringList
        ref={singleRef}
        disabled={disabled || isStructAgent()}
        data={response.singlePrompts || []}
        update={(values: string[]) => {
          this.handleUpdateResponseByField(
            idx,
            response,
            'singlePrompts',
            values
          );
        }}
      />
    },
    {
      key: 'zero-prompts',
      label: localizedString('value_suggestion_zero_prompts'),
      extra: response.zeroPrompts && response.zeroPrompts.length && <AddButton
        disabled={disabled || isStructAgent()}
        onClick={(e: any) => {
          zeroRef.current?.add(e);
        }} /> || '',
      content: <PromptStringList
        ref={zeroRef}
        disabled={disabled || isStructAgent()}
        data={response.zeroPrompts || []}
        update={(values: string[]) => {
          this.handleUpdateResponseByField(
            idx,
            response,
            'zeroPrompts',
            values
          );
        }}
      />
    }];

    // 若为单渠道模式，不使用 tabList，保持原逻辑
    if (singleChannel) {
      return (
        <NiCard
          title={
            <span className="response__title">
              <span>
                <Space size={32}>
                  <span
                    key="title"
                    className="response__title_text"
                    style={{ marginRight: 16 }}
                  >
                    {localizedString(
                      singleAction
                        ? 'list_reply_display'
                        : 'response_type_list_action'
                    )}
                  </span>
                </Space>
              </span>
            </span>
          }
          className="response-card"
          key={`response-block-${ActionType.LIST}-${idx}`}
          extra={
            (disabled || singleAction) ? (
              []
            ) : (
              <NiButton
                style={{ border: 0 }}
                onClick={this.handleDeleteResponse.bind(this, idx)}
              >
                <DeleteOutlined />
              </NiButton>
            )
          }
          hoverExtra={true}
        >

          <NiForm
            titleline
            hideTitleForSingle={hideSource}
            direction="vertical"
            items={[
              !hideSource && {
                key: 'source',
                label: localizedString('list_reply_closure'),
                content: (
                  <>
                    <CodeTextArea
                      inModal={this.props.inModal}
                      dataId="source"
                      disabled={disabled}
                      data={response.source}
                      language="kotlin"
                      update={(nextSource: string) => {
                        this.handleUpdateResponseByField(
                          idx,
                          response,
                          'source',
                          nextSource
                        );
                      }}
                      completionContext={
                        {
                          rawCodeType: frame
                        }
                      }
                    />
                  </>),
              } || undefined,
              {
                key: 'inform',
                label: 'Inform for multiple items',
                content: (<>
                  <div style={{ padding: 16, border: defaultBorder, borderRadius: defaultBorderRadius }}>
                    <NiForm direction="vertical"
                      items={[
                        {
                          key: 'delimiter',
                          label: <Space size={32}>
                            {!hideNumberOfEntries && (
                              <span key="number">
                                <span
                                  className="response__title_num"
                                  style={{ marginRight: 16 }}
                                >
                                  <FormattedMessage id="text_list_action_count" />:
                                </span>
                                <InputNumber
                                  style={{ width: 50 }}
                                  className="num_input"
                                  min={1}
                                  defaultValue={response.itemSize}
                                  disabled={disabled}
                                  onBlur={(e: any) => {
                                    this.handleUpdateResponseByField(
                                      idx,
                                      response,
                                      'itemSize',
                                      parseInt(e.target.value, 10)
                                    );
                                  }}
                                />
                              </span>
                            )}
                            <span key="delimiter">
                              <span style={{ marginRight: 16, marginLeft: 16 }}>
                                {localizedString('list_reply_delimiter')}:
                              </span>
                              <NiInput
                                key="single-delimiter"
                                disabled={disabled || isStructAgent()}
                                style={{ width: 60, marginRight: 8 }}
                                defaultValue={response.delimiterField}
                                placeholder={localizedString(
                                  'list_reply_delimiter_field'
                                )}
                                onBlur={(e: any) => {
                                  if (e.target.value === response.delimiterField) {
                                    return;
                                  }
                                  this.handleUpdateResponseByField(
                                    idx,
                                    response,
                                    'delimiterField',
                                    e.target.value
                                  );
                                }}
                              />
                              <NiInput
                                key="zero-delimiter"
                                disabled={disabled || isStructAgent()}
                                style={{ width: 60 }}
                                defaultValue={response.delimiterEnd}
                                placeholder={localizedString('list_reply_delimiter_end')}
                                onBlur={(e: any) => {
                                  if (e.target.value === response.delimiterEnd) {
                                    return;
                                  }
                                  this.handleUpdateResponseByField(
                                    idx,
                                    response,
                                    'delimiterEnd',
                                    e.target.value
                                  );
                                }}
                              />
                            </span>
                          </Space>
                        },
                        {
                          key: 'header',
                          label: 'Header',
                          content: (
                            <CodeTextArea
                              dataId="header"
                              inModal={this.props.inModal}
                              disabled={disabled || isStructAgent()}
                              data={response.header}
                              update={(next: string) => {
                                const nextResponse = cloneDeep(response);
                                nextResponse.header = next;
                                this.handleUpdateResponse(idx, nextResponse);
                              }}
                            />
                          ),
                        },
                        {
                          key: 'body',
                          label: 'Body',
                          content: (
                            <CodeTextArea
                              dataId="body"
                              inModal={this.props.inModal}
                              disabled={disabled || isStructAgent()}
                              data={response.body || ''}
                              update={(next: string) => {
                                const nextResponse = cloneDeep(response);
                                nextResponse.body = next;
                                this.handleUpdateResponse(idx, nextResponse);
                              }}
                            />
                          ),
                        },
                        {
                          key: 'footer',
                          label: 'Footer',
                          content: (
                            <CodeTextArea
                              dataId="footer"
                              inModal={this.props.inModal}
                              disabled={disabled || isStructAgent()}
                              data={response.footer}
                              update={(next: string) => {
                                const nextResponse = cloneDeep(response);
                                nextResponse.footer = next;
                                this.handleUpdateResponse(idx, nextResponse);
                              }}
                            />
                          ),
                        },
                      ]}
                    />
                  </div>
                </>
                ),
              },
              ...promptItems
            ]}
          />
        </NiCard>
      );
    }

    // 非单渠道模式：使用 card 的 tabList 替换原 NiTabs
    const restful = INTEGRATION_TYPE.RESTFUL;
    const otherChannels = response.otherChannelData || [];
    const channels = [restful, ...otherChannels.map(item => item.channel)];
    const activeTabKey =
      (this.state.listActiveTabs && this.state.listActiveTabs[idx]) || channels[0];

    let tabContent;
    if (activeTabKey === restful) {
      tabContent = (
        <NiForm
          key="restful"
          direction="vertical"
          items={[
            {
              key: 'source',
              label: localizedString('list_reply_closure'),
              content: (
                <>
                  <CodeTextArea
                    inModal={this.props.inModal}
                    dataId="source"
                    disabled={disabled}
                    data={response.source}
                    language="kotlin"
                    update={(nextSource: string) => {
                      this.handleUpdateResponseByField(
                        idx,
                        response,
                        'source',
                        nextSource
                      );
                    }}
                    completionContext={
                      {
                        rawCodeType: frame
                      }
                    }
                  />
                </>),
            },
            {
              key: 'inform',
              label: 'Inform for multiple items',
              content: (<>
                <div style={{ padding: 16, border: defaultBorder, borderRadius: defaultBorderRadius }}>
                  <NiForm direction="vertical"
                    items={[{
                      key: 'delimiter',
                      label: <Space>
                        {!hideNumberOfEntries && (
                          <span key="number">
                            <span
                              className="response__title_num"
                              style={{ marginRight: 16 }}
                            >
                              <FormattedMessage id="text_list_action_count" />:
                            </span>
                            <InputNumber
                              style={{ width: 50 }}
                              className="num_input"
                              min={1}
                              defaultValue={response.itemSize}
                              disabled={disabled}
                              onBlur={(e: any) => {
                                this.handleUpdateResponseByField(
                                  idx,
                                  response,
                                  'itemSize',
                                  parseInt(e.target.value, 10)
                                );
                              }}
                            />
                          </span>
                        )}
                        <span key="delimiter">
                          <span style={{ marginRight: 16, marginLeft: 16 }}>
                            {localizedString('list_reply_delimiter')}:
                          </span>
                          <NiInput
                            key="single-delimiter"
                            disabled={disabled || isStructAgent()}
                            style={{ width: 60, marginRight: 8 }}
                            defaultValue={response.delimiterField}
                            placeholder={localizedString('list_reply_delimiter_field')}
                            onBlur={(e: any) => {
                              if (e.target.value === response.delimiterField) return;
                              this.handleUpdateResponseByField(
                                idx,
                                response,
                                'delimiterField',
                                e.target.value
                              );
                            }}
                          />
                          <NiInput
                            key="zero-delimiter"
                            disabled={disabled || isStructAgent()}
                            style={{ width: 60 }}
                            defaultValue={response.delimiterEnd}
                            placeholder={localizedString('list_reply_delimiter_end')}
                            onBlur={(e: any) => {
                              if (e.target.value === response.delimiterEnd) return;
                              this.handleUpdateResponseByField(
                                idx,
                                response,
                                'delimiterEnd',
                                e.target.value
                              );
                            }}
                          />
                        </span>
                      </Space>
                    },
                    {
                      key: 'header',
                      label: 'Header',
                      content: (
                        <CodeTextArea
                          inModal={this.props.inModal}
                          disabled={disabled || isStructAgent()}
                          data={response.header}
                          update={(next: string) => {
                            const nextResponse = cloneDeep(response);
                            nextResponse.header = next;
                            this.handleUpdateResponse(idx, nextResponse);
                          }}
                        />
                      ),
                    },
                    {
                      key: 'body',
                      label: 'Body',
                      content: (
                        <CodeTextArea
                          inModal={this.props.inModal}
                          disabled={disabled || isStructAgent()}
                          data={response.body}
                          update={(next: string) => {
                            const nextResponse = cloneDeep(response);
                            nextResponse.body = next;
                            this.handleUpdateResponse(idx, nextResponse);
                          }}
                        />
                      ),
                    },
                    {
                      key: 'footer',
                      label: 'Footer',
                      content: (
                        <CodeTextArea
                          inModal={this.props.inModal}
                          disabled={disabled || isStructAgent()}
                          data={response.footer}
                          update={(next: string) => {
                            const nextResponse = cloneDeep(response);
                            nextResponse.footer = next;
                            this.handleUpdateResponse(idx, nextResponse);
                          }}
                        />
                      ),
                    }]}
                  />
                </div>
              </>
                // <ReferenceTextArea
                //   disableReferenceMode
                //   initParameters={suggestionData}
                //   parameterMap={ParameterMapStore.all()}
                //   allowNewLine={true}
                //   rawCodeMode={true}
                //   rawCodeType={frame}
                //   rawCodeExprMode={ExprMode.condition}
                //   disabled={disabled}
                //   placeholder={localizedString('code_condition_placeholder')}
                //   className="reset"
                //   data={response.source}
                //   update={(nextSource: string) => {
                //     this.handleUpdateResponseByField(
                //       idx,
                //       response,
                //       'source',
                //       nextSource
                //     );
                //   }}
                //   comment={response.sourceComment}
                //   onCommentChange={(next: string) => {
                //     this.handleUpdateResponseByField(
                //       idx,
                //       response,
                //       'sourceComment',
                //       next
                //     );
                //   }}
                // />
              ),
            },

            ...promptItems
          ]}
        />
      );
    } else {
      const tabIndex = channels.indexOf(activeTabKey) - 1;
      tabContent = (
        <NiForm
          key={activeTabKey}
          direction="vertical"
          items={[
            {
              key: 'source',
              label: localizedString('list_reply_closure'),
              content: (
                <>
                  <CodeTextArea
                    inModal={this.props.inModal}
                    dataId="source"
                    disabled={disabled}
                    data={response.source}
                    language="kotlin"
                    update={(nextSource: string) => {
                      this.handleUpdateResponseByField(
                        idx,
                        response,
                        'source',
                        nextSource
                      );
                    }}
                    completionContext={
                      {
                        rawCodeType: frame
                      }
                    }
                  />
                </>),
            },
            {
              key: 'inform',
              label: 'Inform for multiple items',
              content: (<>
                <div style={{ padding: 16, border: defaultBorder, borderRadius: defaultBorderRadius }}>
                  <NiForm direction="vertical"
                    items={[{
                      key: 'delimiter',
                      label: <Space>
                        {!hideNumberOfEntries && (
                          <span key="number">
                            <span
                              className="response__title_num"
                              style={{ marginRight: 16 }}
                            >
                              <FormattedMessage id="text_list_action_count" />:
                            </span>
                            <InputNumber
                              style={{ width: 50 }}
                              className="num_input"
                              min={1}
                              defaultValue={response.itemSize}
                              disabled={disabled}
                              onBlur={(e: any) => {
                                this.handleUpdateResponseByField(
                                  idx,
                                  response,
                                  'itemSize',
                                  parseInt(e.target.value, 10)
                                );
                              }}
                            />
                          </span>
                        )}
                        <span key="delimiter">
                          <span style={{ marginRight: 16, marginLeft: 16 }}>
                            {localizedString('list_reply_delimiter')}:
                          </span>
                          <NiInput
                            key="single-delimiter"
                            disabled={disabled || isStructAgent()}
                            style={{ width: 60, marginRight: 8 }}
                            defaultValue={response.delimiterField}
                            placeholder={localizedString('list_reply_delimiter_field')}
                            onBlur={(e: any) => {
                              if (e.target.value === response.delimiterField) return;
                              this.handleUpdateResponseByField(
                                idx,
                                response,
                                'delimiterField',
                                e.target.value
                              );
                            }}
                          />
                          <NiInput
                            key="zero-delimiter"
                            disabled={disabled || isStructAgent()}
                            style={{ width: 60 }}
                            defaultValue={response.delimiterEnd}
                            placeholder={localizedString('list_reply_delimiter_end')}
                            onBlur={(e: any) => {
                              if (e.target.value === response.delimiterEnd) return;
                              this.handleUpdateResponseByField(
                                idx,
                                response,
                                'delimiterEnd',
                                e.target.value
                              );
                            }}
                          />
                        </span>
                      </Space>
                    },
                    {
                      key: 'header',
                      label: 'Header',
                      content: (
                        <CodeTextArea
                          inModal={this.props.inModal}
                          disabled={disabled || isStructAgent()}
                          data={
                            (response.otherChannelData &&
                              response.otherChannelData[tabIndex].header) ||
                            ''
                          }
                          update={(next: string) => {
                            const nextResponse = cloneDeep(response);
                            if (activeTabKey === restful) {
                              nextResponse.header = next;
                            } else {
                              if (!nextResponse.otherChannelData) {
                                nextResponse.otherChannelData = [
                                  { channel, header: '', body: '', footer: '' },
                                ];
                              }
                              nextResponse.otherChannelData[tabIndex].header = next;
                            }
                            this.handleUpdateResponse(idx, nextResponse);
                          }}
                        />
                      ),
                    },
                    {
                      key: 'body',
                      label: 'Body',
                      content: (
                        <CodeTextArea
                          inModal={this.props.inModal}
                          disabled={disabled || isStructAgent()}
                          data={
                            (response.otherChannelData &&
                              response.otherChannelData[tabIndex].body) ||
                            ''
                          }
                          update={(next: string) => {
                            const nextResponse = cloneDeep(response);
                            if (activeTabKey === restful) {
                              nextResponse.body = next;
                            } else {
                              if (!nextResponse.otherChannelData) {
                                nextResponse.otherChannelData = [
                                  { channel, header: '', body: '', footer: '' },
                                ];
                              }
                              nextResponse.otherChannelData[tabIndex].body = next;
                            }
                            this.handleUpdateResponse(idx, nextResponse);
                          }}
                        />
                      ),
                    },
                    {
                      key: 'footer',
                      label: 'Footer',
                      content: (
                        <CodeTextArea
                          inModal={this.props.inModal}
                          disabled={disabled || isStructAgent()}
                          data={
                            (response.otherChannelData &&
                              response.otherChannelData[tabIndex].footer) ||
                            ''
                          }
                          update={(next: string) => {
                            const nextResponse = cloneDeep(response);
                            if (activeTabKey === restful) {
                              nextResponse.footer = next;
                            } else {
                              if (!nextResponse.otherChannelData) {
                                nextResponse.otherChannelData = [
                                  { channel, header: '', body: '', footer: '' },
                                ];
                              }
                              nextResponse.otherChannelData[tabIndex].footer = next;
                            }
                            this.handleUpdateResponse(idx, nextResponse);
                          }}
                        />
                      ),
                    }]}
                  />
                </div>
              </>
              ),
            },

            ...promptItems
          ]}
        />
      );
    }

    return (
      <NiCard
        title={
          < div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <span
              key="title"
              className="response__title_text"
              style={{ marginRight: 16 }}
            >
              {localizedString(
                singleAction
                  ? 'list_reply_display'
                  : 'response_type_list_action'
              )}
            </span>
            {/* 添加 Menu 组件 */}
            {
              !singleChannel && (
                <Menu
                  mode="horizontal"
                  selectedKeys={[activeTabKey]}
                  style={{
                    // marginLeft: 16,
                    lineHeight: '30px',
                    border: 'none',
                    background: 'transparent',
                    width: '100%'
                  }}
                  onClick={(e) => {
                    this.setState((prevState: any) => ({
                      listActiveTabs: { ...prevState.listActiveTabs, [idx]: e.key },
                    }));
                  }}
                >
                  {channels.map((ch, index) => {
                    const isClosable = index !== 0 && !disabled && !frame.originKey;
                    return (
                      <Menu.Item
                        key={ch}
                        style={{
                          padding: '0 8px',
                          borderBottom: activeTabKey === ch ? '2px solid #1890ff' : 'none'
                        }}
                      >
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                          {USER_CHANNEL_NAME_MAP[ch]}
                          {isClosable && (
                            <CloseOutlined
                              onClick={(e) => {
                                e.stopPropagation();
                                // 保持原有的删除逻辑
                                const nextResponse = cloneDeep(response);
                                if (nextResponse.otherChannelData) {
                                  nextResponse.otherChannelData = nextResponse.otherChannelData.filter(
                                    (item: any) => item.channel !== ch
                                  );
                                }
                                this.handleUpdateResponse(idx, nextResponse);
                                if (activeTabKey === ch) {
                                  this.setState((prevState: any) => ({
                                    itemActiveTabs: {
                                      ...prevState.itemActiveTabs,
                                      [idx]: channels[0],
                                    },
                                  }));
                                }
                              }}
                              style={{ marginLeft: 8, fontSize: 12 }}
                            />
                          )}
                        </span>
                      </Menu.Item>
                    );
                  })}
                </Menu>
              )
            }
          </div >
        }
        className="response-card list-reply-card"
        key={`response-block-${ActionType.LIST}-${idx}`}
        extra={
          disabled ? (
            []
          ) : (
            <Space>
              {!frame.originKey && !disabled &&
                <Dropdown
                  key="dropdown"
                  placement="bottomRight"
                  overlay={
                    <Menu
                      key="add-annotation"
                      className="add-annotation"
                    >
                      {Object.entries(INTEGRATION_TYPE)
                        .filter(([label, value]: [string, string]) => value !== INTEGRATION_TYPE.RESTFUL)
                        .map(([label, value]: [string, string]) =>
                          <Menu.Item
                            style={{ height: 40 }}
                            key={`attr-module-option-${label}`}
                            disabled={value === INTEGRATION_TYPE.RESTFUL ||
                              (response.otherChannelData &&
                                response.otherChannelData.findIndex((item: ListActionChannelData) => item.channel === value) > -1)}
                            title={USER_CHANNEL_NAME_MAP[value]}
                            onClick={(e: any) => {
                              const nextResponse = cloneDeep(response);

                              if (!nextResponse.otherChannelData) {
                                nextResponse.otherChannelData = [];
                              }

                              nextResponse.otherChannelData.push({
                                channel: value,
                                header: '',
                                body: '',
                                footer: ''
                              });

                              this.handleUpdateResponse(idx, nextResponse);
                            }}
                          >
                            {USER_CHANNEL_NAME_MAP[value]}
                          </Menu.Item>)
                      }
                    </Menu>
                  }>
                  <div>
                    {/* {localizedString('add_channels')} */}
                    <PlusOutlined key="icon" />
                  </div>
                </Dropdown>
              }
              {
                (!disabled && !singleAction) ?
                  <NiButton
                    style={{ border: 0 }}
                    onClick={this.handleDeleteResponse.bind(this, idx)}
                  >
                    <DeleteOutlined />
                  </NiButton> : ''
              }
            </Space >
          )
        }
        hoverExtra={true}
      >
        {tabContent}
      </NiCard >
    );
  };

  getIntentStartActionDiv = (idx: number, response: IntentStartAction) => {
    const { data } = this.state;
    const { disabled = false, availableIntents = [], selectedParameters, frame } = this.props;

    if (!data) {
      return '';
    }

    const intentId = response && response.intent && response.intent.id;
    const intent = availableIntents.find((item: IntentInfo) => intentId === item.id);

    return (
      <NiCard
        title={<span className="response__title">{localizedString('response_type_intent_action')}</span>}
        className="response-card"
        key={`response-block-${ActionType.INTENT_START}-${idx}`}
        extra={disabled ? [] : <NiButton
          style={{
            border: 0
          }}
          onClick={this.handleDeleteResponse.bind(this, idx)}
        >
          <DeleteOutlined />
        </NiButton>}
        hoverExtra={true}
      >
        <NiForm
          direction="vertical"
          items={[
            {
              key: 'gated',
              label: 'Boolean gated',
              labelExtra: <Switch checked={response.gated} onChange={(checked: boolean) => {
                const nextResponse = cloneDeep(response);
                nextResponse.gated = checked;
                this.handleUpdateResponse(idx, nextResponse);
              }}
              />
            },
            {
              key: 'intent',
              label: localizedString('response_type_intent_action'),
              content: <NiSelect
                showSearch
                listHeight={300}
                filterOption={(input, option: any) =>
                  (option.children || '').toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: '100%' }}
                disabled={disabled}
                value={intentId && intentId.length && intentId || undefined}
                onChange={async (value: string) => {

                  if (intentId !== value) {
                    await API.agentResponse.checkIntentActionDependency(value)
                      .catch((err: any) => {
                        message.warning(err.message);
                        throw new Error(err.message);
                      });
                  }

                  let selected: any = availableIntents.find((item: IntentInfo) => item.id === value);
                  if (selected) {
                    this.handleUpdateResponseByField(idx, response, 'intent', selected && {
                      id: selected.id,
                      name: selected.name,
                      type: ParameterType.INTENT
                    });
                    return;
                  }

                  selected = selectedParameters.find((item: Attribute) =>
                    item.id === value);
                  if (selected) {
                    this.handleUpdateResponseByField(idx, response, 'intent', selected && {
                      id: selected.id,
                      name: selected.name,
                      type: ParameterType.ATTRIBUTE
                    });
                  }
                }}
              >
                {
                  availableIntents.map((intent: IntentInfo) =>
                    <NiSelect.Option
                      disabled={intent.attributes.findIndex((slot: Attribute) =>
                        slot.proto && slot.proto.type === ParameterType.INTENT) !== -1}
                      key={intent.id}
                      value={intent.id || ''}>
                      {getFormattedName(intent)}
                    </NiSelect.Option>)
                }
                {
                  selectedParameters.filter((item: Attribute) =>
                    item.proto && item.proto.name === 'io.framely.core.IIntent')
                    .map((item: Attribute) =>
                      <NiSelect.Option key={item.id} value={item.id || ''}>
                        {item.name}
                      </NiSelect.Option>
                    )
                }
              </NiSelect>
            },
            {
              key: 'assignments',
              label: localizedString('intent_assignment'),
              content: <NiTable
                pagination={false}
                dataSource={response.assignments || []}
                rowKey="slot.id"
                columns={[{
                  title: localizedString('target_slot'),
                  dataIndex: 'slot',
                  width: '30%',
                  render: (_: any, record: IntentAssignment, index: number) => {
                    return <NiSelect
                      style={{ width: '100%' }}
                      disabled={disabled}
                      value={(record.slot && record.slot.length && record.slot[0].id || null) as any}
                      onChange={(value: string) => {
                        const nextAssignments = cloneDeep(response.assignments);
                        if (intent) {
                          const slot = intent.attributes.find((item: Attribute) => item.id === value);

                          if (slot) {
                            const nextAssignment = nextAssignments[index];
                            nextAssignment.slot = [{
                              id: slot.id as string,
                              type: ParameterType.ATTRIBUTE,
                              name: slot.name as string
                            }];
                            nextAssignments[index] = nextAssignment;
                          }
                        }

                        this.handleUpdateResponseByField(idx, response, 'assignments', nextAssignments);
                      }}
                    >
                      {
                        intent && intent.attributes.map((item: Attribute) =>
                          <NiSelect.Option key={item.id} value={item.id || ''}>
                            {item.name}
                          </NiSelect.Option>)
                      }
                    </NiSelect>;
                  }
                }, {
                  title: localizedString('code_expression'),
                  dataIndex: 'codeExpression',
                  width: '65%',
                  render: (codeExpression: string, record: IntentAssignment, index: number) => {
                    return <ReferenceTextArea
                      rawCodeMode
                      rawCodeType={frame}
                      disabled={disabled}
                      data={codeExpression}
                      initParameters={[]}
                      parameterMap={{}}
                      update={(next: string) => {
                        const nextAssignments = cloneDeep(response.assignments);
                        const nextAssignment = nextAssignments[index];
                        nextAssignment.codeExpression = next;
                        nextAssignments[index] = nextAssignment;
                        this.handleUpdateResponseByField(idx, response, 'assignments', nextAssignments);
                      }}
                      comment={record.codeComment}
                      onCommentChange={(next: string) => {
                        const nextAssignments = cloneDeep(response.assignments);
                        const nextAssignment = nextAssignments[index];
                        nextAssignment.codeComment = next;
                        nextAssignments[index] = nextAssignment;
                        this.handleUpdateResponseByField(idx, response, 'assignments', nextAssignments);
                      }}
                    />;
                  }
                }, {
                  title: !(disabled) &&
                    <PlusOutlined
                      onClick={() => {
                        const nextAssignments = cloneDeep(response.assignments || []);
                        nextAssignments.push({ slot: [], codeExpression: '' });
                        this.handleUpdateResponseByField(idx, response, 'assignments', nextAssignments, true);
                      }}
                    /> || '',
                  width: '5%',
                  dataIndex: 'operation',
                  render: (_: any, record: IntentAssignment, index: number) => {
                    return !(disabled) &&
                      <DeleteOutlined
                        onClick={(e: any) => {
                          e.stopPropagation();
                          e.preventDefault();
                          const nextAssignments = cloneDeep(response.assignments);
                          nextAssignments.splice(index, 1);
                          this.handleUpdateResponseByField(idx, response, 'assignments', nextAssignments);
                        }}
                      /> || '';
                  }
                }]}
              />
            }
          ]}
        />
      </NiCard>
    );
  };

  getIntentAbortActionDiv = (idx: number, response: IntentAbortAction) => {
    const { data } = this.state;
    const { disabled = false, availableIntents = [], selectedParameters } = this.props;

    if (!data) {
      return '';
    }

    const intentId = response && response.intent && response.intent.id;

    return (
      <NiCard
        title={localizedString('response_type_intent_abort_action')}
        className="response-card"
        key={`response-block-${ActionType.INTENT_ABORT}-${idx}`}
        extra={disabled ? [] : <NiButton
          style={{
            border: 0
          }}
          onClick={this.handleDeleteResponse.bind(this, idx)}
        >
          <DeleteOutlined />
        </NiButton>}
        hoverExtra={true}
      >
        <NiForm
          direction="vertical"
          items={[{
            key: 'intent',
            label: localizedString('action_intent_abort_target_intent'),
            content: <NiSelect
              showSearch
              listHeight={300}
              filterOption={(input, option: any) =>
                (option.children || '').toLowerCase().includes(input.toLowerCase())
              }
              style={{ width: '100%' }}
              disabled={disabled}
              value={intentId && intentId.length && intentId || undefined}
              onChange={async (value: string) => {

                if (intentId !== value) {
                  await API.agentResponse.checkIntentActionDependency(value)
                    .catch((err: any) => {
                      message.warning(err.message);
                      throw new Error(err.message);
                    });
                }

                let selected: any = availableIntents.find((item: IntentInfo) => item.id === value);
                if (selected) {
                  this.handleUpdateResponseByField(idx, response, 'intent', selected && {
                    id: selected.id,
                    name: selected.name,
                    type: ParameterType.INTENT
                  });
                  return;
                }

                selected = selectedParameters.find((item: Attribute) =>
                  item.id === value);
                if (selected) {
                  this.handleUpdateResponseByField(idx, response, 'intent', selected && {
                    id: selected.id,
                    name: selected.name,
                    type: ParameterType.ATTRIBUTE
                  });
                }
              }}
            >
              {
                availableIntents.map((intent: IntentInfo) =>
                  <NiSelect.Option key={intent.id} value={intent.id || ''}>
                    {getFormattedName(intent)}
                  </NiSelect.Option>)
              }
              {
                selectedParameters.filter((item: Attribute) =>
                  item.proto && item.proto.name === 'io.framely.core.IIntent')
                  .map((item: Attribute) =>
                    <NiSelect.Option key={item.id} value={item.id || ''}>
                      {item.name}
                    </NiSelect.Option>
                  )
              }
            </NiSelect>
          }]}
        />
      </NiCard>
    );
  };

  getHandOffActionDiv = (idx: number, response: HandOffAction) => {
    const { data } = this.state;
    const { disabled = false, availableIntents = [], selectedParameters } = this.props;

    if (!data) {
      return '';
    }


    return (
      <NiCard
        title={localizedString('response_type_hand_off_action')}
        className="response-card"
        key={`response-block-${ActionType.HAND_OFF}-${idx}`}
        extra={disabled ? [] : <NiButton
          style={{
            border: 0
          }}
          onClick={this.handleDeleteResponse.bind(this, idx)}
        >
          <DeleteOutlined />
        </NiButton>}
        hoverExtra={true}
      >
      </NiCard>
    );
  };

  getCloseSessionActionDiv = (idx: number, response: CloseSessionAction) => {
    const { data } = this.state;
    const { disabled = false, availableIntents = [], selectedParameters } = this.props;

    if (!data) {
      return '';
    }

    return (
      <NiCard
        title={localizedString('response_type_close_session_action')}
        className="response-card no-content"
        key={`response-block-${ActionType.CLOSE_SESSION}-${idx}`}
        extra={disabled ? [] : <NiButton
          style={{
            border: 0
          }}
          onClick={this.handleDeleteResponse.bind(this, idx)}
        >
          <DeleteOutlined />
        </NiButton>}
        hoverExtra={true}
      >
      </NiCard>
    );
  };

  handleUpdateResponseByField = (
    idx: number,
    response: any,
    field: string,
    nextValue: any,
    withoutSubmit?: boolean
  ) => {

    if (response[field] === nextValue) {
      return;
    }

    const nextResponse = cloneDeep(response);
    nextResponse[field] = nextValue;
    this.handleUpdateResponse(idx, nextResponse, withoutSubmit);
  }

  handleUpdateResponse = (idx: number, action: FramelyAction, withoutSubmit?: boolean) => {
    // const { data } = this.state;
    // const target = cloneDeep(data);

    // if (!target) {
    //   return;
    // }

    // target[idx] = action;


    // this.setState({
    //   data: target
    // }, !withoutSubmit && this.onChange || undefined);

    this.setState(prevState => {
      const target = cloneDeep(prevState.data);
      if (target) {
        target[idx] = action;
      }
      return { data: target };

    }, !withoutSubmit && this.onChange || undefined);
  }

  handleDeleteResponse = (deletedIndex: number) => {


    this.setState((prevState) => {

      const { data } = prevState;
      const target = cloneDeep(data);

      if (!target) {
        return;
      }
      target.splice(deletedIndex, 1);

      const newItemActiveTabs: { [index: number]: string } = {};
      const newListActiveTabs: { [index: number]: string } = {};

      // 更新 itemActiveTabs：保留 deletedIndex 之前的；大于 deletedIndex 的键 - 1
      Object.keys(prevState.itemActiveTabs).forEach(key => {
        const idx = Number(key);
        if (idx < deletedIndex) {
          newItemActiveTabs[idx] = prevState.itemActiveTabs[idx];
        } else if (idx > deletedIndex) {
          newItemActiveTabs[idx - 1] = prevState.itemActiveTabs[idx];
        }
        // 如果 idx === deletedIndex，则直接跳过（即删除该项）
      });

      // 同理更新 listActiveTabs
      Object.keys(prevState.listActiveTabs).forEach(key => {
        const idx = Number(key);
        if (idx < deletedIndex) {
          newListActiveTabs[idx] = prevState.listActiveTabs[idx];
        } else if (idx > deletedIndex) {
          newListActiveTabs[idx - 1] = prevState.listActiveTabs[idx];
        }
      });

      return {
        itemActiveTabs: newItemActiveTabs,
        listActiveTabs: newListActiveTabs,
        data: target
      };
    }, this.onChange);
  };

  onChange = () => {
    const next = cloneDeep(this.state.data);
    this.props.onChange(next);
  }

  handleAddAction = (value: string) => {
    const { data } = this.state;

    const target = cloneDeep(data);

    switch (value) {
      case ActionType.CLEAR_SLOT:
        target.push({
          type: 'clear_slot_action',
          slot: []
        });
        break;
      case ActionType.FILL_SLOT:
        target.push({
          type: 'fill_slot_action',
          slot: [],
          codeExpression: ''
        });
        break;
      case ActionType.RECHECK:
        target.push({
          type: 'recheck_action',
          slot: []
        });
        break;
      case ActionType.INTENT_END:
        target.push({
          type: 'intent_end_action',
          soft: false
        });
        break;
      case ActionType.ITEM:
        target.push({
          type: 'item_action',
          content: [''],
          templateId: ''
        });
        break;
      case ActionType.LIST:
        target.push({
          type: 'list_action',
          sourceType: SourceType.CODE_EXPRESSION,
          source: '',
          variable: [],
          parameters: [],
          header: '',
          footer: '',
          body: '',
          templateId: '',
          itemSize: 5,
          delimiterField: '\\n'
        });
        break;
      case ActionType.INTENT_START:
        target.push({
          type: 'intent_start_action',
          intent: {
            id: '',
            name: '',
            type: ParameterType.INTENT
          },
          assignments: []
        });
        break;
      case ActionType.INTENT_ABORT:
        target.push({
          type: 'intent_abort_action',
          intent: {
            id: '',
            name: '',
            type: ParameterType.INTENT
          }
        });
        break;
      case ActionType.HAND_OFF:
        target.push({
          type: 'hand_off_action',
          department: {
            id: '',
            name: '',
            type: ParameterType.CONTENT
          }
        });
        break;
      case ActionType.CLOSE_SESSION:
        target.push({
          type: 'close_session_action'
        });
        break;
      case ActionType.AUGMENT_META:
        target.push({
          type: 'augment_meta',
          prompt: '',
          structuredOutput: false
        });
        break;
      default:
        break;
    }

    this.setState({
      data: target
    }, this.onChange);
  }
}
